import MaterialIcon from "@/components/MaterialIcon";
import cn from "@/util/cn";

/** A green checkmark + date, or a plus button to log the action (Patient Ed. / Live Int.). */
export const ClinicalStatusCell = ({ date, onAdd }: { date: string | null; onAdd: () => void }) =>
  date ? (
    <span className="flex items-center gap-2">
      <span className="flex size-5 items-center justify-center rounded-full bg-teal-400 text-white">
        <MaterialIcon iconName="check" style={{ fontSize: "14px" }} />
      </span>
      <span className="text-primary/90">{date}</span>
    </span>
  ) : (
    <button
      type="button"
      onClick={onAdd}
      className="flex h-7 w-9 cursor-pointer items-center justify-center rounded-full border border-primary/30 text-primary/80 hover:bg-primary/5"
    >
      <MaterialIcon iconName="add" style={{ fontSize: "18px" }} />
    </button>
  );

export const ClinicalTimeCell = ({ minutes }: { minutes: number }) => (
  <span className="text-primary/90">{minutes} min</span>
);

// TODO: Use the orange background once we have a backend
export const NoteButton = ({ unread, onClick }: { unread: boolean; onClick: () => void }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label="Open sticky note"
    className={cn(
      "flex size-9 cursor-pointer items-center justify-center rounded-md border text-primary/80 hover:bg-primary/5",
      unread ? "border-orange-300 bg-orange-100" : "border-primary/20"
    )}
  >
    <MaterialIcon iconName="sticky_note_2" style={{ fontSize: "18px" }} />
  </button>
);
